import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import { formatCompetitionName } from '../../../helpers';

const Title = ({match}) => {
    const competition = !_.isEmpty(match) ? formatCompetitionName(match.competition, match.journee, match.cpType) : '';
    const split = _.split(competition, '-');
    return(
        <div style={{lineHeight: '20px', paddingTop: '15px', fontSize: 14}} className="ls_live_page title">
        {
            split.map((v,i) => {
                return <div key={i} style={{fontFamily: 'fff-equipe'}}>{v}</div>
            })
        }
            <div style={{fontFamily: 'fff-equipe', fontWeight: 600}}>{ !_.isEmpty(match) && moment(match.date, 'YYYYMMDDHHmm').locale('fr').format('D MMMM YYYY - HH:mm') }</div>
        </div>
    );
}

export default Title;